/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorNewScorecardRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.new-scorecard',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorNewScorecardRoute);
